import { endpoints } from "./endpoints";
import request from "../request";
// import stores from '../../stores/index.js'

export function create(data, onUploadProgress = null) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.createEntrega,
      method: "post",
      data,
      onUploadProgress,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function saveEntregaTask(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.saveEntregaTask,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function getTasksWithApprovals(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.getTasksWithApprovals,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

export function setTaskApproval(data) {
  return new Promise((resolve, reject) => {
    const config = {
      url: endpoints.setTaskApproval,
      method: "post",
      data,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    request(config)
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

export function bulkSetTaskApprovals(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.bulkSetTaskApprovals,
      method: "post",
      data,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then(function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

export function getApprovalHistory(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.getApprovalHistory,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

export function addPlano(data, onUploadProgress = null) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.addPlano,
      method: "post",
      data,
      onUploadProgress,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

export function markForgeFileAsBlueprint(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.markForgeFileAsBlueprint,
      method: 'post',
      data,
    })
      .then(function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

export function addProtocolo(data, onUploadProgress = null) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.addProtocolo,
      method: "post",
      data,
      onUploadProgress,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

/**
 * Actualizar un protocolo existente
 *
 * @param {Object} data - Datos del protocolo a actualizar
 * @param {Function} onUploadProgress - Callback para progreso de carga (opcional)
 * @returns {Promise}
 */
export function updateProtocolo(data, onUploadProgress = null) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.updateProtocolo,
      method: "post",
      data,
      onUploadProgress,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function list(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.listEntrega,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function updateEntrega(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.updateEntrega,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
/**
 * Close/finalize an entrega
 *
 * @param {Object} data - Entrega closing data
 * @returns {Promise}
 */
export function closeEntrega(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.closeEntrega,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function approveSupervisor(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.approveSupervisor,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function getApprovalAttachment(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.getApprovalAttachment,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

export function getEntregaByID(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.getEntregaByID,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function addInteraction(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.addEntregaInteraction,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function closeRDI(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.closeRDI,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function markEntregaAsRead(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.markEntregaAsRead,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function downloadPDF(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.downloadEntregaPDF,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function getEntregaGraphs(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.getEntregaGraphs,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function getPlanos(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.getPlanos,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
/**
 * Save a task approval or autocontrol status
 *
 * @param {Object} data - Task approval data
 * @returns {Promise}
 */
export function saveTask(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.saveTask,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

/**
 * Enable autocontrol for all tasks in an entrega
 *
 * @param {Object} data - Entrega data
 * @returns {Promise}
 */
export function enableAutocontrolTotal(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.enableAutocontrolTotal,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function saveConfig(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.saveConfig,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

export function getProtocolos(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.getProtocolos,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function getConfig(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.getConfig,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function getPlano(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.getPlano,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function updatePlano(data, onUploadProgress = null) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.updatePlano,
      method: "post",
      data,
      onUploadProgress,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function sendRDIMail(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.sendRDIMail,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
export function deleteRdi(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.deleteRdi,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

export function changeVisualizationStatus(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.changeVisualizationStatusRdi,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

/**
 * Eliminar un plano del sistema
 *
 * @param {Object} data - Datos del plano a eliminar (id y project_id)
 * @returns {Promise}
 */
export function deletePlano(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.deletePlano,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

/**
 * Obtener todos los protocolos disponibles para importar
 *
 * @returns {Promise}
 */
export function getAllProtocolos(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.getAllProtocolos,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

/**
 * Copiar protocolos seleccionados a un proyecto
 *
 * @param {Object} data - Datos con project_id y protocol_ids
 * @returns {Promise}
 */
export function copyProtocolsToProject(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.copyProtocolsToProject,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

export function editPlanoEntrega(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.editPlanoEntrega,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

export function deleteEntrega(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.deleteEntrega,
      method: "delete",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

export function exportEntregaGraphsPDF(data) {
  return new Promise((resolve, reject) => {
    request({
      url: endpoints.exportEntregaGraphsPDF,
      method: "post",
      data,
    })
      .then(async function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}